export default {
  SET_LOADING: 'SET_LOADING',
  SET_ERROR: 'SET_ERROR',
  SET_COMPONENT: 'SET_COMPONENT',
  SET_SECTION: 'SET_SECTION',
  SET_CURR_CUSTOMIZATIONS: 'SET_CURR_CUSTOMIZATIONS',
  EDIT_MODE: 'EDIT_MODE',
  ENABLE_SAVE: 'ENABLE_SAVE',
};
